<div class="notifications-wrapper">
  <header>
    <div class="title-header">
      <div class="headline-medium">Notificaciones</div>
      <div class="mark-read button-default-text">Marcar como leídos</div>
    </div>

    <div class="divider"></div>
  </header>

  <div class="notifications-list-wrapper">
    <div class="notifications-list">
      <div
        *ngFor="let notificacion of notificaciones$ | async"
        class="notification-item-wrapper">
        <div class="indicator-wrapper">
          <div
            class="indicator"
            [ngClass]="{ unread: !notificacion.Leido }"></div>
        </div>
        <div class="notification-item" (click)="onNotificationClick(notificacion.CodNotificacion)">
          <div class="notification-icon">
            <img
              [ngClass]="{ unread: !notificacion.Leido }"
              [src]="'assets/icons/yalo-line.svg'"
              alt="yalo-line" />
          </div>
          <div class="info">
            <div class="headline-tiny">
              {{ notificacion.NombreNotificacion }}
            </div>
            <div class="body-x-small truncate" style="color: #808080">
              {{ notificacion.DescripcionNotificacion }}
            </div>
          </div>
          <div class="date" style="color: #808080">
            <div class="body-x-small">
              <yalo-pills [icon]="getCategory(notificacion.CodCategoria)?.Icon"
                [background]="getCategory(notificacion.CodCategoria)?.Color">{{getCategory(notificacion.CodCategoria)?.Nombre}}</yalo-pills>
            </div>
            <div class="body-x-small">{{ notificacion.FechaCreacion | timeAgo }}</div>
          </div>
        </div>
      </div>
    </div>

    <a
      class="goto button-default-text"
      routerLink="/notificaciones"
      (click)="popoverController.dismiss()">Ver todas</a>
  </div>
</div>